export default __webpack_public_path__ + "static/media/save.fc8c47f0.svg";